import { USER_ACTION_TYPES } from '../../actions/user/user_action';
import { ROLE_ADMIN, ROLE_MANAGER, ROLE_DOCTOR, ROLE_WORKER } from '../../../constants/constants';

const initialState = {};

export const user = (state = initialState, action) => {
    switch(action.type) {
        case USER_ACTION_TYPES.SIGN_IN_AUTHENTICATE_USER:
            const { uuid } = action.payload;
            return { uuid };
        case USER_ACTION_TYPES.GET_SIGNED_USER_DATA:
            const isDoctor = action.payload.roles?.some(role => role === ROLE_DOCTOR);
            const isWorker = action.payload.roles?.some(role => role === ROLE_WORKER);
            const isManager = action.payload.roles?.some(role => role === ROLE_MANAGER);
            const isAdmin = action.payload.roles?.some(role => role === ROLE_ADMIN);
            return { ...action.payload, isDoctor, isWorker, isManager, isAdmin };
        default:
            return state;
    }
}
